// extracted by mini-css-extract-plugin
export var card = "staffList-module--card--6MTwZ";
export var card__avatar = "staffList-module--card__avatar--NKmtD";
export var card__contact = "staffList-module--card__contact--UcA5K";
export var card__email = "staffList-module--card__email--q-GXL";
export var card__initials = "staffList-module--card__initials--eNdK-";
export var card__name = "staffList-module--card__name--lR74a";
export var staffList = "staffList-module--staffList--8cbxo";
export var staffList__container = "staffList-module--staffList__container--ihfdl";